import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
  path: '/threePartyTest',
  name: ' threePartyTest',
  meta: {
    title: '三方试题管理',
    keepAlive: false
  },
  component: Layout,
  redirect: '/threePartyTest/index',
  children: [
    {
      path: 'index',
      name: 'indexs',
      meta: {
        title: '试题分配列表',
        keepAlive: false
      },
      component: resolve => require(['@/views/threePartTest/testAllocation/Index.vue'], resolve),
    },
    {
      path: '/threePartyTest/audit',
      name: 'audit',
      meta: {
        title: '审核列表',
        keepAlive: false
      },
      component: resolve => require(['@/views/threePartTest/Audit/Index.vue'], resolve),
    },
    {
      path: '/threePartyTest/historsyList',
      name: 'historsyList',
      meta: {
        title: '历史记录',
        keepAlive: false
      },
      component: resolve => require(['@/views/threePartTest/components/historsyList.vue'], resolve),
    },
    {
      path: '/threePartyTest/auditRadioTest',
      name: 'auditRadioTest',
      meta: {
        title: '审核试题预览',
        keepAlive: false
      },
      component: resolve => require(['@/views/threePartTest/components/RadioTestA1Detail.vue'], resolve),

    },
    {
      path: '/threePartyTest/auditRadioA3Test',
      name: 'auditRadioA3Test',
      meta: {
        title: '审核试题预览',
        keepAlive: false
      },
      component: resolve => require(['@/views/threePartTest/components/RadioTestA3Detail.vue'], resolve),

    },
    {
      path: '/threePartyTest/auditRadioBTest',
      name: 'auditRadioBTest',
      meta: {
        title: '审核试题预览',
        keepAlive: false
      },
      component: resolve => require(['@/views/threePartTest/components/RadioTestBDetail.vue'], resolve),

    },
    {
      path: '/threePartyTest/auditCheckedA1Test',
      name: 'auditCheckedA1Test',
      meta: {
        title: '审核试题预览',
        keepAlive: false
      },
      component: resolve => require(['@/views/threePartTest/components/CheckedTestA1Detail.vue'], resolve),

    },
    {
      path: '/threePartyTest/auditCheckedA4Test',
      name: 'auditCheckedA4Test',
      meta: {
        title: '审核试题预览',
        keepAlive: false
      },
      component: resolve => require(['@/views/threePartTest/components/CheckedTestA4Detail.vue'], resolve),

    },
  ]
}


